// extracted by mini-css-extract-plugin
export default {"inline":"src-views-common-components-Icon-Icon__inline--gfLOa"};